import { darken, tint } from 'polished';

import { cofThemeTwo } from '../../../components/_ThemeTwo_';

import { backgroundTint, defaultDatePicker, defaultModal, IThemeInterface } from './common';

const buttonFocusDarken = 0.05;
const buttonAlertHoverTint: number = 0.93;
const headerBackgroundTint: number = 0.95;
const tableFilterBackgroundTint: number = 0.9;

const colorBrandPrimary: string = '#1d517b';
const colorBrandPrimarySoft: string = tint(backgroundTint, colorBrandPrimary);
const colorBrandSecondary: string = '#1973b8';
const colorBrandTertiary: string = '#227a3e';
const colorBrandWarning: string = '#e61e25';
const colorBannerAlert: string = '#b32138';
const colorBrandLink: string = '#1973b8';
const colorBrandLinkHover: string = '#1466a5';

const colorButtonDisabled: string = '#e9e9e9';

const colorButtonPrimary: string = '#1973b8';
const colorBrandAlert: string = '#da3851';
const colorButtonAlertHover: string = tint(
  buttonAlertHoverTint,
  colorBrandAlert,
);

const colorSlate: string = '#1d517b';
const colorSlate5: string = '#f4f4f4';
const colorSlate10: string = '#cfcfcf';
const colorSlate50: string = '#757575';
const colorSlate70: string = colorSlate;
const colorBrandText: string = '#121212';
const colorWhite: string = '#fff';
export const colorSlate6: string = '#666666';

const BbvaTheme: IThemeInterface = {
  name: 'bbva',
  outline: '2px solid #0069aa',
  globalAnchorDecoration: 'underline',
  colorBackground: colorWhite,
  colorLineHeight: '2.2rem',
  workflowLinkTextDecoration: 'none',

  colorWhite,
  colorSlate5,
  colorSlate10,
  colorSlate20: '#bebebe',
  colorSlate50,
  colorSlate70,
  colorSlate,
  colorBlack: '#424242',

  actionButton: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorTextActive: colorWhite,
    colorBorder: colorSlate10,
    colorBorderHover: colorButtonPrimary,
    colorBackgroundActive: colorButtonPrimary,
  },
  alert: {
    borderWidth: '1px',
    alert: {
      colorBackground: '#faeaea',
      colorText: colorBrandText,
      colorBorder: colorBrandAlert,
    },
    success: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    primary: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    secondary: {
      colorBackground: '#e6f7f3',
      colorText: colorBrandText,
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBackground: tint(backgroundTint, colorBrandWarning),
      colorText: colorBrandText,
      colorBorder: colorBrandWarning,
    },
    inactive: {
      colorBackground: colorSlate5,
      colorText: colorBrandText,
      colorBorder: colorSlate5,
    },
    default: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
  },
  banner: {
    alert: {
      colorBorder: colorBannerAlert,
      colorBackground: colorBannerAlert,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    success: {
      colorBorder: colorBrandPrimary,
      colorBackground: colorBrandPrimary,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    primary: {
      colorBorder: colorBrandPrimary,
      colorBackground: colorBrandPrimary,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    secondary: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    warning: {
      colorBorder: colorBrandWarning,
      colorBackground: colorBrandWarning,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    inactive: {
      colorBorder: colorSlate5,
      colorBackground: colorSlate5,
      colorText: colorSlate,
      colorLink: colorSlate,
    },
    default: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorSlate,
      colorLink: colorSlate,
    },
    linkTextWeight: '600',
    sectionBackground: colorSlate10,
    paddingBanner: '1.283em',
    fontSizeBannerText: '14px',
    fontWeightBanner: '600',
  },
  bannerSection: {
    colorBackground: colorSlate,
  },
  brand: {
    colorPrimary: colorBrandPrimary,
    colorPrimarySoft: colorBrandPrimarySoft,
    colorSecondary: colorBrandSecondary,
    colorWarning: colorBrandWarning,
    colorAlert: colorBrandAlert,
  },
  button: {
    primary: {
      boxShadow: 'none',
      padding: '0.907em 1.25em',
      colorBackground: colorButtonPrimary,
      colorBackgroundHover: colorBrandLinkHover,
      colorBackgroundFocus: colorBrandLinkHover,
      colorBorder: colorButtonPrimary,
      colorBorderHover: colorBrandLinkHover,
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: '#666666',
    },
    secondary: {
      boxShadow: 'none',
      padding: '0.907em 1.25em',
      colorBackground: colorWhite,
      colorBackgroundHover: colorWhite,
      colorBackgroundFocus: tint('0.9', colorBrandLinkHover),
      colorBackgroundDisabled: colorWhite,
      colorBorder: colorButtonPrimary,
      colorBorderHover: colorButtonPrimary,
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorButtonPrimary,
      colorTextHover: colorButtonPrimary,
      colorTextDisabled: colorButtonDisabled,
    },
    alert: {
      boxShadow: 'none',
      padding: '0.907em 1.25em',
      colorBackground: colorWhite,
      colorBackgroundHover: colorButtonAlertHover,
      colorBackgroundFocus: darken(buttonFocusDarken, colorButtonAlertHover),
      colorBackgroundDisabled: colorWhite,
      colorBorder: colorBrandAlert,
      colorBorderHover: colorBrandAlert,
      colorBorderDisabled: colorSlate10,
      colorText: colorBrandAlert,
      colorTextHover: colorBrandAlert,
      colorTextDisabled: colorSlate10,
    },

    letterSpacing: 'normal',
    fontWeight: '700',
    fontSize: '1.6rem',
    textTransform: 'none',
    borderRadius: '0',
    borderWidth: '2px',
    tinySize: '1.2rem',
    tinyPadding: '0.5em 2em',
    baseButtonMinWidth: '15.063em',
  },
  card: {
    borderRadius: '2px',
    borderWidth: '1px',
    colorBorder: colorSlate10,
    colorBackground: colorWhite,
    boxShadow: 'none',
  },
  checkbox: {
    colorBorder: colorSlate10,
    colorBackground: colorSlate5,
    colorBackgroundChecked: colorSlate5,
    colorBackgroundAlert: colorSlate5,
    fontSize: '1.6rem',
  },
  datepicker: {
    ...defaultDatePicker
  },
  header: {
    colorBreadcrumbText: colorBrandText,
    colorHeaderDrawerLinkAboveSmallBP: colorBrandLink,
    colorLink: colorBrandLink,
    colorLinkHover: colorBrandLinkHover,
    colorSubNavLink: colorBrandText,
    colorSubNavLinkHover: colorBrandLinkHover,
    subNavBreakPoint: 'large',
    summaryWeight: '700',
  },
  headline: {
    small: {
      size: '1.6rem',
      sizeResponsive: '1.6rem',
      lineHeightResponsive: '1.2',
      lineHeight: '1.2',
      letterSpacing: 'normal',
      weight: '700',
      colorText: colorBrandText,
      displayTypeface: 'benton_sans',
    },
    medium: {
      size: '2.4rem',
      sizeResponsive: '2.4rem',
      lineHeight: '1.2',
      lineHeightResponsive: '1.2',
      letterSpacing: 'normal',
      weight: '600',
      colorText: colorBrandPrimary,
      displayTypeface: 'benton_sans',
    },
    large: {
      size: '3.6rem',
      sizeResponsive: '3.6rem',
      lineHeight: '1.4',
      lineHeightResponsive: '1.4',
      letterSpacing: '1.29px',
      weight: '700',
      colorText: colorBrandPrimary,
      displayTypeface: 'benton_sans',
    },
  },
  icon: {
    brandText: {
      colorIcon: colorBrandText,
    },
    brand: {
      colorIcon: colorBrandPrimary,
    },
    link: {
      colorIcon: colorBrandPrimary,
    },
    grey: {
      colorIcon: colorSlate10,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
    },
    tertiary: {
      colorIcon: colorWhite,
    },
    error: {
      colorIcon: colorBrandAlert,
    },
  },
  input: {
    boxShadowHover: 'none',
    boxShadowAlert: 'none',
    colorBorder: colorSlate10,
    colorBackground: colorSlate5,
    colorPlaceholder: '#999',
    colorFocus: colorButtonPrimary,
    colorTextAreaBorder: colorSlate50,
    colorTextAreaBackground: colorWhite,
    borderRadius: '0',
    borderWidth: '1px',
    padding: '0.75em',
    selectInputBackgroundSvgFocused: '',
    textAreaPadding: '0.75em',
  },
  label: {
    datapointWeight: '400',
    formLabelColor: colorBrandText,
    formLabelMargin: '0.5em',
    formLabelWeight: '500',
    smallTypeWeight: '700',
    fontWeight: '500',
    size: '1.4rem',
    spacing: 'normal',
    textTransform: 'none',
    cardLabelSize: '1.6rem',
  },
  link: {
    colorLink: colorBrandLink,
    colorLinkIcon: colorBrandPrimary,
    colorLinkHover: colorBrandLinkHover,
  },
  modal: {
    ...defaultModal,
    colorText: colorBrandText,
    colorHeadlineText: colorBrandPrimary,
    colorDrawerBorder: colorSlate10,
    colorDrawerHover: colorBrandText,
    colorDrawerBackgroundHover: colorSlate10,
    colorBoxShadow: '0 3px 20px 8px rgba(0, 0, 0, 0.1)',
    colorBackground: 'rgba(255, 255, 255, 0.8)',
    colorClose: colorSlate,
    borderRadius: '5px',
  },
  notification: {
    success: {
      colorBorder: colorBrandSecondary,
    },
    error: {
      colorBorder: colorBrandWarning,
    },
    info: {
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBorder: colorBrandWarning,
    },
    widthBorder: '0.5em',
    spacing: '1em',
    colorHover: colorBrandPrimary,
  },
  pill: {
    alert: {
      colorBackground: colorBrandAlert,
      colorText: colorWhite,
    },
    success: {
      colorBackground: colorBrandTertiary,
      colorText: colorWhite,
    },
    primary: {
      colorBackground: colorBrandSecondary,
      colorText: colorWhite,
    },
    secondary: {
      colorBackground: colorBrandSecondary,
      colorText: colorWhite,
    },
    warning: {
      colorBackground: colorBrandWarning,
      colorText: colorWhite,
    },
    inactive: {
      colorBackground: colorSlate5,
      colorText: 'inherit',
    },
    default: {
      colorBackground: colorBrandTertiary,
      colorText: colorWhite,
    },
    letterSpacing: 'normal',
    padding: '0 0.75em',
    borderRadius: '2px',
    textTransform: 'uppercase',
    fontSize: '1rem',
  },
  progress: {
    colorBar: colorButtonPrimary,
    colorCircularBackground: colorSlate10,
    colorBarBackground: 'transparent',
    colorBarBorder: colorButtonPrimary,
    circularWeight: '700',
    circularSize: '3.6rem',
  },
  progressTracker: {
    colorCompleted: colorBrandPrimary,
    colorOutstanding: colorSlate10,
    colorProgressTrackerBackground: tint('0.9', colorSlate10),
    colorTextOutstanding: colorBrandText,
    colorTextCompleted: colorBrandText,
    colorStepBgCompleted: colorBrandTertiary,
    colorStepBorderCompleted: colorBrandTertiary,
    colorStepBgOutstanding: colorSlate5,
    colorStepBorderOutstanding: colorSlate5,
    colorHrOutstanding: colorSlate10,
    colorHrCompleted: colorBrandTertiary,
    headerContainerPadding: '0.75em 0',
    hrHorizontalOffset: '16px',
    hrVerticalOffset: '-27px',
    hrWidth: '96.4px',
    iconCheckedDone: 'done',
    stepLabelFontWeight: '400',
    stepLabelHorizontalOffset: '0.5em',
    stepNumberFontWeight: '700',
    stepNumberFontSize: '1.6rem',
    stepNumberVerticalOffset: '2px',
    svgCompletedHeight: '17.5px',
    svgCompletedWidth: '17.5px',
    trackerIndicatorWidth: '34px',
    trackerIndicatorHeight: '34px',
    trackerWrapperWidth: '162px',
  },
  radio: {
    boxShadow: colorBrandAlert,
    boxShadowHover: 'transparent',
    colorBorder: colorSlate50,
    colorBorderHover: colorSlate50,
    colorBorderChecked: colorBrandPrimary,
    colorBackground: colorWhite,
    colorBackgroundHover: tint(backgroundTint, colorBrandPrimary),
    colorBackgroundChecked: tint(backgroundTint, colorBrandPrimary),
    colorText: colorSlate50,
    colorTextHover: colorSlate50,
    colorTextChecked: colorBrandPrimary,
    colorTextAlert: colorBrandAlert,
    padding: '0.6em 0.75em',
    borderWidth: '1px',
    fontWeight: '700',
  },
  radioCard: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorBackgroundChecked: tint(backgroundTint, colorBrandPrimary),
  },
  radioInput: {
    borderWidth: '1px',
    borderWidthActive: '1px',
    hasActiveHeightAndWidth: false,
    colorBackground: colorWhite,
    colorInner: colorBrandSecondary,
    colorBorder: colorSlate10,
    colorBorderInactive: colorSlate10,
    colorRadioLabelBackground: colorSlate5,
    colorRadioLabelBackgroundActive: colorSlate5,
    colorRadioButtonHover: colorSlate5,
    sizeRadioButton: '35px',
    sizeRadioButtonHover: '35px',
    sizeRadioButtonInnerMark: '23px',
    positionRadioButtonInnerMarkTop: '0.56em',
    positionRadioButtonInnerMarkLeft: '0.56em',
    labelTextOffset: '0.5em',
  },
  spinner: {
    colorBackground: colorSlate10,
    colorSegment: colorBrandPrimary,
  },
  table: {
    alert: {
      colorIcon: colorBrandAlert,
      colorText: colorBrandAlert,
    },
    success: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandSecondary,
    },
    primary: {
      colorIcon: colorBrandPrimary,
      colorText: colorBrandText,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandText,
    },
    warning: {
      colorIcon: colorBrandWarning,
      colorText: colorBrandText,
    },
    inactive: {
      colorIcon: colorSlate50,
      colorText: colorSlate50,
    },
    default: {
      colorIcon: colorSlate70,
      colorText: colorBrandText,
    },
    filter: {
      colorText: colorBrandText,
      colorTextSelected: colorBrandPrimary,
      colorBackground: tint(tableFilterBackgroundTint, colorBrandPrimary),
      borderRadius: '4px',
    },
    header: {
      colorBackground: colorSlate5,
      colorSubHeaderBackground: tint(headerBackgroundTint, colorBrandPrimary),
      fontWeight: '700',
    },
    colorDetailsButton: colorBrandPrimary,
    colorDivider: colorSlate10,
  },
  taskCard: {
    colorBorder: '#e75545',
    colorText: colorBrandSecondary,
    colorIcon: colorBrandSecondary,
    colorCtaIcon: colorBrandSecondary,
    colorSubhead: colorBrandText,
    colorInReviewBorder: colorBrandSecondary,
    colorCompleteText: colorBrandText,
    fontWeightHeadline: '700',
    fontWeightSubHead: '500',
    hasIcon: true,
  },
  text: {
    colorText: colorBrandText,
    colorCaption: colorBrandText,
  },
  toolTip: {
    paneFontSize: '1.4rem',
    paneBackgroundColor: '#b8e2ff',
    paneBoxShadow: '0 -1px 6px 0 rgba(0,0,0,.3)',
    paneBorderRadius: '2px',
  },
  typography: {
    bodyTypeface: 'benton_sans',
    displayTypeface: 'benton_sans',
  },
  upload: {
    colorBackground: 'rgba(209,209,209,0.3)',
    colorBorder: '#999',
    colorActiveBackground: tint('0.93', 'rgba(209,209,209,0.3)'),
    colorActiveBorder: tint('0.7', '#999'),
    colorText: colorSlate,
    borderStyle: 'dashed',
    borderWidth: '2px',
    size: '20em',
  },
  verifications: {
    mastHeadlineColor: colorBrandText,
  },
  // themeTwo should be removed once themeTwo replaces current theme
  // legacy_partners inherit COF theme two. This is only used so that theme one apps can use the Box component
  themeTwo: { ...cofThemeTwo, name: 'legacy_partner' },
};

export default BbvaTheme;
